import { RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "../i18n";
import { apiFetch } from "../api/apiFetch";

type bayInfo = {
    Date: string,
    Batch: number,
    Lane: string,
    Type: string
}

type baysDataType = {
    Date: string,
    Warehouse: string,
    Batch: number,
    Lane: string,
    Type: string,
    AssignedBay: string
};

const ZoneStorageSettingsBays = ({ warehouse }: { warehouse: "Newport" | "Poland" | "Test" }) => {

    const { t } = useTranslation();

    const emptyBay = { Date: "", Batch: 0, Lane: "" }
    const bays = {
        "Newport": { 1: { Type: "Large", ...emptyBay }, 2: { Type: "Large", ...emptyBay }, 3: { Type: "Medium", ...emptyBay }, 4: { Type: "Medium", ...emptyBay }, 5: { Type: "Small", ...emptyBay }, 6: { Type: "Small", ...emptyBay }, 7: { Type: "PutWall", ...emptyBay }, 8: { Type: "PutWall", ...emptyBay } },
        "Poland": { 1: { Type: "Large", ...emptyBay }, 2: { Type: "Large", ...emptyBay }, 3: { Type: "Large", ...emptyBay }, 4: { Type: "Large", ...emptyBay }, 5: { Type: "Large", ...emptyBay }, 6: { Type: "Medium", ...emptyBay }, 7: { Type: "Small", ...emptyBay }, 8: { Type: "PutWall", ...emptyBay }, 9: { Type: "PutWall", ...emptyBay } },
        "Test": { 1: { Type: "Large", ...emptyBay }, 2: { Type: "Medium", ...emptyBay }, 3: { Type: "Small", ...emptyBay }, 4: { Type: "PutWall", ...emptyBay } }
    };

    const [baysData, set_baysData] = useState<{ [key: number]: bayInfo }>(bays[warehouse]);
    const [reloading, set_reloading] = useState<boolean>(false);

    useEffect(() => {

        const init = async () => {
            // Fetch lanes that are in use and assigned to bays

            await apiFetch(`/zonestorage/lanes/get-lanes-in-use-by-bays`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ warehouse: warehouse })
            }).then(async (res): Promise<any> => {
                let response: baysDataType[] = await res.json();

                // Update baysData with the fetched data
                let updatedBaysData: { [key: number]: bayInfo } = bays[warehouse];

                response.forEach((item: baysDataType) => {
                    const bayNumber = parseInt(item.AssignedBay);

                    if (updatedBaysData[bayNumber]) {
                        updatedBaysData[bayNumber] = {
                            Date: item.Date,
                            Batch: item.Batch,
                            Lane: item.Lane,
                            Type: item.Type
                        };
                    }
                });

                set_baysData(updatedBaysData);

            })
        };

        init();

    }, [warehouse]);

    const reload_bays = async () => {
        set_reloading(true);
        // Fetch lanes that are in use and assigned to bays
        await apiFetch(`/zonestorage/lanes/get-lanes-in-use-by-bays`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ warehouse: warehouse })
        }).then(async (res): Promise<any> => {
            let response: baysDataType[] = await res.json();

            // Update baysData with the fetched data
            let updatedBaysData: { [key: number]: bayInfo } = bays[warehouse];

            response.forEach((item: baysDataType) => {
                const bayNumber = parseInt(item.AssignedBay);

                if (updatedBaysData[bayNumber]) {
                    updatedBaysData[bayNumber] = {
                        Date: item.Date,
                        Batch: item.Batch,
                        Lane: item.Lane,
                        Type: item.Type
                    };
                }
            });

            set_baysData(updatedBaysData);
        })

        set_reloading(false);
    };


    return (
        <div className="zone-settings-group">
            <div>
                <div className="flex-apart">
                    <h1 className="zone-settings-group-header">{t("sorter_2_bay_info")}</h1>
                    <RefreshCw className={"refresh-button " + (reloading ? "reload-spin" : "")} onClick={() => reload_bays()} />
                </div>
            </div>

            <div className="zone-settings-batch-container">

                {Object.keys(baysData).length > 0 ? Object.entries(baysData).map(([bayNumber, data]) => {
                    return (
                        <div className={"zone-settings-bay-group"} key={bayNumber}>
                            <h1>{t("bay_title", { number: bayNumber, type: data.Type })}</h1>
                            {data.Date !== "" ? <>
                                <p>{t("lane_label", { lane: String(data.Lane) })}</p>
                                <p>{t("date_label", { date: new Date(data.Date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') })}</p>
                                <p>{t("batch_label", { batch: String(data.Batch) })}</p>
                            </> : <p>{t("unassigned")}</p>}
                        </div>
                    );
                }) : <h1>{t("no_data")}</h1>}

            </div>

        </div>
    );
};

export default ZoneStorageSettingsBays;
